import { Flex as BaseFlex } from 'mds-web-ui'
import shouldForwardProp from '@styled-system/should-forward-prop'
import React from 'react'
import styled from 'styled-components'
import { border, layout, space, typography } from 'styled-system'

import { Paragraph, fontSizes } from '../utils/Typography'

export const ShareWithUs = ({ ...props }) => {
  return (
    <Flex
      bg="#000"
      color="#fff"
      borderRadius={16}
      justifyContent="space-between"
      alignItems="center"
      flexDirection={['column', 'row']}
      p={[3, 4]}
      gap={[3, 4]}
      {...props}
    >
      <Paragraph
        m={0}
        fontSize={fontSizes.copy}
        color="inherit"
        textAlign={['center', 'left']}
        pt={[2, 0]}
        px={[2, 0]}
        animate={false}
      >
        Made something amazing in Flow and want to share it with the world?
      </Paragraph>

      <CallToActionLink
        bg="#fff"
        color="#000"
        fontSize={fontSizes.copy}
        css={{ whiteSpace: 'pre' }}
        width={['100%', 'auto']}
        href="mailto:flow@moleskinestudio.com?subject=Sharing work on Flow Gallery"
        rel="noreferrer"
        target="_blank"
      >
        Contact us
      </CallToActionLink>
    </Flex>
  )
}

const Flex = styled(BaseFlex)({}, border)

const CallToActionLink = styled('a')
  .withConfig({
    shouldForwardProp
  })
  .attrs(props => ({
    color: '#000',
    bg: '#fff',
    py: 3,
    px: 4,
    fontSize: fontSizes.body,
    ...props
  }))(
  {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    whiteSpace: 'pre',

    color: '#000',
    backgroundColor: '#fff',
    cursor: 'pointer',

    fontWeight: 600,
    textDecoration: 'none',

    border: 0,
    borderRadius: '8px',

    transition: '120ms all ease-out',

    zIndex: 5,

    '&:hover': {
      transform: 'scale(1.02)'
    },

    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.5
    }
  },
  space,
  typography,
  layout
)
